export default {
  reportBuilder: 'Kreator raportów',
  subheadline: 'Te ustawienia definiują globalny wygląd plików PDF generowanych przez Qmulus.',
};
